const commonDefaultState = {
  isAuthenticated: false,
  canViewerShare: false,
  canEditPresentation: false,
  currentTokenValue: null,
  ahaSequenceNumber: 0,
  offsetTime: 0,
}

export default commonDefaultState
